import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_speed_dial = _resolveComponent("v-speed-dial")!
  const _component_v_fab = _resolveComponent("v-fab")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { flat: "" }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_component_v_fab, {
        key: $setup.fabPosition,
        absolute: $setup.fabPosition === 'absolute',
        app: $setup.fabPosition === 'fixed',
        color: $setup.open ? '' : 'primary',
        location: $setup.fabLocation,
        size: "large",
        icon: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.open ? 'mdi-close' : 'mdi-crown'), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_speed_dial, {
            modelValue: $setup.open,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.open) = $event)),
            location: $setup.menuLocation,
            transition: $setup.transition,
            activator: "parent"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.items, (item) => {
                return (_openBlock(), _createBlock(_component_v_tooltip, {
                  key: item.key,
                  "open-on-hover": true
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps({ ref_for: true }, props, {
                      fab: "",
                      size: $setup.fabSize,
                      onClick: ($event: any) => ($setup.go(item.to))
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { size: "28" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.icon), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["size", "onClick"])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(item.title), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue", "location", "transition"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["absolute", "app", "color", "location"]))
    ]),
    _: 1 /* STABLE */
  }))
}